//@flow

import React, { Component } from 'react';
import Rater from 'react-rater';
import capitalize from 'lodash/capitalize';
import getAverage from './utils';

import 'react-rater/lib/react-rater.css';

type RatingsProps = {
  [title: string]: number,
};

type ToolTipRatingsProps = {
  ratings: RatingsProps,
};

export default class ToolTipRatings extends Component<ToolTipRatingsProps> {
  /**
   * @param  {String} title organization_skills
   * @return {String} title Organisational SkiLls
   */

  splitAndCapitalize = (title: string) =>
    title === 'value'
      ? 'Value for Money'
      : title
          .split('_')
          .map(x => capitalize(x))
          .join(' ');

  /**
   *  render ratings object into DOM
   */

  renderRatings = (ratings: RatingsProps) =>
    Object.keys(ratings).map(ratingTitle => {
      const rating = Number(ratings[ratingTitle] / 2);

      return (
        <div className="rating-cat" key={ratingTitle}>
          <h6>{this.splitAndCapitalize(ratingTitle)}:</h6>
          <Rater total={5} rating={rating} interactive={false} />
        </div>
      );
    });

  hasKeys = obj => obj && Object.keys(obj).length > 0;

  render() {
    const { ratings } = this.props;
    const averageRatings = this.hasKeys(ratings) && getAverage(ratings);

    return (
      <div className="rating hg-tooltip user-rating">
        (<Rater total={5} rating={averageRatings || 0} interactive={false} />
        {/* <span className="__star d-inline d-md-none"><i className="icon icon-hg-star " /></span> */}
        <span className="ml-1">{averageRatings || 0}/5</span>)
        <em>{Boolean(ratings) && this.renderRatings(ratings)}</em>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ReviewsRatings/ToolTipRatings.jsx